import { connect } from 'react-redux'
import {
  compose, lifecycle, withState, withHandlers,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfiguration, updateSiteConfigs } from 'actions/Site'
import { fetchVideos, deleteVideo } from 'actions/VideoSimpan'
import VideoSimpanView from 'components/pages/webManagement/videoSimpan/List'
import { message } from 'antd'

export function mapStateToProps(state) {
  const { currentUser } = state.root.auth
  return {
    currentUser,
  }
}

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchVideos: bindActionCreators(fetchVideos, dispatch),
  deleteVideo: bindActionCreators(deleteVideo, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('videoList', 'setVideo', {
    data: [],
    meta: {},
    isFetching: true,
  }),
  withHandlers({
    getVideoList: props => () => {
      props.fetchVideos()
        .then((result) => {
          props.setVideo({
            data: result.data,
            meta: result.meta,
            isFetching: false,
          })
        })
        .catch((error) => {
          props.setVideo({
            data: [],
            meta: {},
            isFetching: false,
          })
          message.error(error.message)
        })
    },
  }),
  withHandlers({
    handleDelete: props => (id) => {
      props.deleteVideo(id)
        .then(() => {
          props.getVideoList()
        })
        .catch((error) => { message.error(error) })
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfiguration('breadList', ['Home', 'Web Management', 'Video Simpan', 'List'])
      this.props.updateSiteConfigs({
        titlePage: 'Video List',
        activePage: 'web-management/video-simpan',
        activeSubPage: 'web-management',
      })
      this.props.getVideoList()
    },
  }),
)(VideoSimpanView)
